var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{stroke-linejoin:round;}.cls-2,.cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:2px;}.cls-3{stroke-miterlimit:10;}.cls-4{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 60,
    height: 60,
    rx: 3.53,
    ry: 3.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.9,
    y1: 53.45,
    x2: 52.84,
    y2: 53.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.16,42.5h6.27c.36,0,.66.3.66.66v7.19h-7.59v-7.19c0-.36.3-.66.66-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20.29,38.5h5.97c.45,0,.81.36.81.81v11.03h-7.59v-11.03c0-.45.36-.81.81-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32.51,30.34h5.49c.58,0,1.05.47,1.05,1.05v18.95h-7.59v-18.95c0-.58.47-1.05,1.05-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44.68,22.5h5.11c.69,0,1.24.56,1.24,1.24v26.6h-7.59v-26.6c0-.69.56-1.24,1.24-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m7.59,32.41c5.83-1.33,15.09-4.19,24.67-10.76,7.36-5.04,12.44-10.58,15.73-14.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.59 14.5 48.09 14.61 47.58 7.23 40.26 8.28 40.05 6.79 48.97 5.52 49.59 14.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.796b1128c3fd75049c3b71ebbd2473ec.svg";
export { ForwardRef as ReactComponent };